import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { AlarmService } from '../../../services/commons/alarm.service';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { CommandConnectorQueueInsRequest } from 'src/app/services/SicorService/RequestObject/CommandConnectorQueueInsRequest';
import { Schedule } from '../../../models/Schedule';
import { AppUserScheduleRequest } from 'src/app/services/SicorService/RequestObject/AppuserScheduleRequest';
import { ModalService } from 'src/app/services/commons/modal.service';

@Component({
  selector: 'app-connect-alarm',
  templateUrl: './connect-alarm.component.html',
  styleUrls: ['./connect-alarm.component.scss'],
})
export class ConnectAlarmComponent implements OnInit {

  @Input('action') action: string
  @Input('user') user: string;
  public modal_title: string;
  public modal_subtitle: string;
  public switchOff: boolean = false;
  @Input('schedule') schedule: Schedule;
  @Input('oldSchedules') oldSchedules: Schedule[];
  public newSchedule: Schedule;
  public setIntID;
  public expirationTime = new Date();
  private isServiceBusy = false;

  constructor(private modalCtrl: ModalController,
    private translate: TranslateConfigService,
    private gvs: GlobalVariablesService,
    private alarmService: AlarmService,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
    public modalService: ModalService
  ) { }

  async ngOnInit() {
    if (this.action == 'connect') {
      this.modal_title = await this.translate.getTranslate('MODAL.connectAlarm.title');
      this.modal_subtitle = await this.translate.getTranslate('MODAL.connectAlarm.subtitle');
    } else if (this.action == 'disconnect') {
      this.modal_title = await this.translate.getTranslate('MODAL.disconnectAlarm.title');
      this.modal_subtitle = await this.translate.getTranslate('MODAL.disconnectAlarm.subtitle');
      this.switchOff = true;
    }
  }

  dismiss(confirm: boolean, result?: boolean, schedule?: Schedule) {
    this.modalCtrl.dismiss({ confirm: confirm, result: result, schedule: schedule }, '', 'connectAlarmModal');
  }

  ionViewWillEnter() {
    if(this.action === 'connect'){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Activar Alarma', contentGroup: 'Home'});
    }
    else{
      this.gms.analyticsTrackEvent('openScreen', {screenName: 'Desactivar Alarma', contentGroup: 'Home'});
    }
  }

  async connectDisconnect() {
    if (this.isServiceBusy) {
      return;
    }
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.isServiceBusy = true;
      await this.gms.loading();
      let connectDisconnectAlarmRequest: CommandConnectorQueueInsRequest;
      if (!this.switchOff) {
        connectDisconnectAlarmRequest = new CommandConnectorQueueInsRequest(this.user, this.gvs.currentInstallation.s_ins,
          "", "ARM", "TOTAL", 0, "||schix:0||");
      } else {
        connectDisconnectAlarmRequest = new CommandConnectorQueueInsRequest(this.user, this.gvs.currentInstallation.s_ins,
          "", "DISARM", "", 0, "||schix:0||");
      }
      const response = await this.alarmService.connectDisconnectAlarm(connectDisconnectAlarmRequest, 'connectAlarm');
      if (response) {
        this.expirationTime = new Date();
        this.expirationTime.setSeconds(this.expirationTime.getSeconds() + 20);
        this.setIntID = setInterval(async () => {
          await this.loadStatusInstallation();
        }, 2000);
        /*await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), !this.switchOff ? await this.translate.getTranslate('MESSAGES.connectAlarmOk') + ' '+this.gvs.currentInstallation.ins_name
        : await this.translate.getTranslate('MESSAGES.disconnectAlarmOk') + ' '+this.gvs.currentInstallation.ins_name, 'modal-default', await this.translate.getTranslate('BUTTON.agreed'));*/
      } else {
        if (this.switchOff){
          this.gms.analyticsTrackEvent('alarm_activation', {eventCategory: 'SICOR/Desactivar Alarma', eventAction: 'Accion/Desactivar Alarma', eventLabel:'Error/InternalServerError'});
        }
        else{
          this.gms.analyticsTrackEvent('alarm_activation', {eventCategory: 'SICOR/Activar Alarma', eventAction: 'Accion/Activar Alarma', eventLabel:'Error/InternalServerError'});

        }
        if (response != undefined) {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), !this.switchOff ? await this.translate.getTranslate('MESSAGES.connectAlarmKo') + ' ' + this.gvs.currentInstallation.ins_name
          : await this.translate.getTranslate('MESSAGES.disconnectAlarmKo') + ' ' + this.gvs.currentInstallation.ins_name, 'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        this.modalCtrl.dismiss(false, '', 'loadingModal');}
      }
      this.isServiceBusy = false;
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async loadStatusInstallation() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      const appUserScheduleRequest: AppUserScheduleRequest = new AppUserScheduleRequest(this.user, this.gvs.currentInstallation.s_ins);
      const schedules: Schedule[] = await this.alarmService.getSchedules(appUserScheduleRequest, 'connectAlarm');
      if (schedules === undefined) {
        this.clearIntervalStatusInstallation();
        return;
      }
      this.newSchedule = schedules.find(x => x.schix === 10);
      let changeDetected = false;
      this.oldSchedules.forEach(oldSchedule => {
        let newSchedule = schedules.find(x => x.schix === oldSchedule.schix);
        if (oldSchedule.type !== newSchedule.type) {
          changeDetected = true;
        }
      });
      if (changeDetected) {
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        await clearInterval(this.setIntID);
        setTimeout(async () => {
          this.dismiss(true, true, this.newSchedule);
        }, 500);
      }
      if (!changeDetected && new Date(this.expirationTime) < new Date()) {
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        await clearInterval(this.setIntID);
        setTimeout(async () => {
          this.dismiss(true, false, this.newSchedule);
        }, 500);
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  clearIntervalStatusInstallation() {
    window.clearInterval(this.setIntID);
    this.setIntID = 0;
  }
}